import { formatTonFromNano } from "@/shared/lib/pvpRouletteMath"

/**
 * Conservative reserve for an outbound TON transfer (amount + comment payload).
 * Keeps "deposit all" from failing when the wallet must also pay network fees.
 */
export const TON_WALLET_DEPOSIT_TX_FEE_RESERVE_NANO = 10_000_000 // 0.01 TON

const MAX_DEPOSIT_NANO = 99_999 * 1e9

/** Max sendable deposit from on-chain balance (nanotons), after fee reserve and app cap. */
export function maxTonDepositNano(walletBalanceNano: number): number {
  if (!Number.isFinite(walletBalanceNano) || walletBalanceNano <= 0) return 0
  const afterFee = Math.max(
    0,
    Math.floor(walletBalanceNano) - TON_WALLET_DEPOSIT_TX_FEE_RESERVE_NANO
  )
  return Math.min(afterFee, MAX_DEPOSIT_NANO)
}

/** Parse UI decimal string (up to 9 fractional digits) to integer nanotons. */
export function parseTonDecimalToNano(value: string): number | null {
  const trimmed = value.trim().replace(",", ".")
  if (!trimmed || trimmed === ".") return null
  const match = /^(\d+)(?:\.(\d*))?$/.exec(trimmed)
  if (!match) return null
  const whole = match[1]
  const frac = (match[2] ?? "").slice(0, 9)
  const nano =
    BigInt(whole) * BigInt(1e9) +
    BigInt(frac.padEnd(9, "0").slice(0, 9) || "0")
  if (nano > BigInt(Number.MAX_SAFE_INTEGER)) return null
  const asNumber = Number(nano)
  return Number.isFinite(asNumber) && asNumber > 0 ? asNumber : null
}

/** Fixed TON preset (e.g. 7.5) → nanotons without float drift. */
export function tonPresetToNano(ton: number): number {
  return Math.round(ton * 1e9)
}

export function formatTonDepositDisplay(nano: number): string {
  return formatTonFromNano(nano, { allowZero: true })
}

export function walletBalanceNanoToTon(nano: number): number {
  return nano / 1e9
}
